<template>
  <v-ons-list-item
    modifier="longdivider"
    @click="showDetail"
  >
    <div class="center">
      <section class="destination-outline">
        <h1 class="destination-outline-title">{{ areaName }}</h1>
        <p>{{ restroom.name }}</p>
        <v-ons-row
          vertical-align="bottom"
          class="destination-restroom-detail"
        >
          <v-ons-col
            :class="['destination-restroom-icon', restroom.gender]"
            width="30px"
          >
            <img :src="icon">
          </v-ons-col>

          <v-ons-col
            v-if="isAvailable"
            class="destination-restroom-status available"
            width="1.5em"
          >空</v-ons-col>

          <v-ons-col
            v-else
            class="destination-restroom-status unavailable"
            width="1.5em"
          >満</v-ons-col>

          <v-ons-col class="destination-restroom-count">
            残り
            {{ Math.max(numberOfSeats - numberOfPerson, 0) }} / {{ numberOfSeats }}
          </v-ons-col>
        </v-ons-row>
      </section>
    </div>
    <div class="right">
      <img
        :src="image"
        width="130px"
        class="image-thumb"
      >
    </div>
  </v-ons-list-item>
</template>

<script>
const noimage = require('@/assets/images/noimage.svg');
const iconMale = require('@/assets/images/icon-restroom-male.svg');
const iconFemale = require('@/assets/images/icon-restroom-female.svg');
const iconShared = require('@/assets/images/icon-restroom-shared.svg');

export default {
  props: {
    restroom: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    floorId: ({ restroom }) => restroom.floor.id,
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    image: ({ restroom }) => restroom.image.thumb.url || noimage,
    icon() {
      let genderIcon;
      if (this.restroom.gender === 'male') genderIcon = iconMale;
      if (this.restroom.gender === 'female') genderIcon = iconFemale;
      if (this.restroom.gender === 'shared') genderIcon = iconShared;

      return genderIcon;
    },
    numberOfSeats: ({ restroom }) => restroom.numberOfSeats,
    numberOfPerson: ({ restroom, numberOfSeats }) => {
      const number = restroom.spotState ? Number(restroom.spotState.numberOfPerson) : 0;
      return number > numberOfSeats ? numberOfSeats : number;
    },
    isAvailable() {
      return this.numberOfPerson < this.numberOfSeats;
    },
    areaName: (vm) => vm.$store.getters['area/buildingAndFloorNameByFloorId'](vm.restroom.floor.id),
  },
  methods: {
    showDetail() {
      // NOTE: 詳細画面では遷移させない
      if (!this.$el.hasAttribute('tappable')) return;

      // NOTE: 別の建物にある場合は移動する
      if (this.currentFloorId !== this.floorId) this.$store.commit('current/setFloorId', this.floorId);

      this.$store.commit('current/setDestination', this.restroom);
      this.$store.dispatch('searchResult/getSpot', this.restroom.id);
      this.$store.dispatch('destinationDetail/show');
    },
  },
};
</script>

<style scoped lang="scss">
.destination-restroom {
  background-color: transparent;
  &-detail {
    flex-wrap: nowrap;
    margin-top: 5px;
    line-height: 1;
  }
  &-icon {
    text-align: center;
  }
  &-status {
    text-align: center;
    font-size: 2em;
  }
  &-count {
    line-height: 1.2em;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// restroom.vue?29decda4